import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../settings.service';

@Component({
  selector: 'edu-zoom-callback',
  templateUrl: './zoom-callback.component.html',
  styleUrls: ['./zoom-callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ZoomCallbackComponent implements OnInit {
  isLoading = true;
  errorMessage = '';
  successMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private settingsService: SettingsService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const error = params['error'];

      if (error) {
        this.errorMessage = 'Authorization was denied or failed';
        this.isLoading = false;
        this.redirectToSettings();
        return;
      }

      if (!code) {
        this.errorMessage = 'No authorization code received';
        this.isLoading = false;
        this.redirectToSettings();
        return;
      }

      this.linkZoomAccount(code);
    });
  }

  private linkZoomAccount(code: string): void {
    this.settingsService.linkZoomAccount(code).subscribe({
      next: (response) => {
        console.log('Zoom account linked successfully:', response);
        this.successMessage = 'Zoom account linked successfully!';
        this.isLoading = false;

        setTimeout(() => {
          // Pass zoomEmail back to settings page
          this.router.navigate(['/portal/settings'], {
            queryParams: {
              zoomLinked: 'success',
              zoomEmail: response.zoomEmail, // ← Pass the zoomEmail
            },
          });
        }, 2000);
      },
      error: (error) => {
        console.error('Error linking Zoom account:', error);
        this.errorMessage =
          error.error?.message || 'Failed to link Zoom account';
        this.isLoading = false;
        this.redirectToSettings();
      },
    });
  }

  private redirectToSettings(): void {
    setTimeout(() => {
      this.router.navigate(['/portal/settings']);
    }, 3000);
  }
}
